import React from "react";

function SalonGridPending(props) {
  const { children } = props;

  return <>{children}</>;
}

export default SalonGridPending;
